import { Button, Menu, Text } from "@mantine/core";
import { IconCheck, IconPlus } from "@tabler/icons-react";
import type { DashboardCatalog, DashboardReportOption } from "../../types/api";

interface ReportPickerProps {
  catalog: DashboardCatalog;
  layoutKeys: Set<string>;
  onAdd: (report: DashboardReportOption) => void;
}

export function ReportPicker({ catalog, layoutKeys, onAdd }: ReportPickerProps) {
  if (catalog.groups.length === 0) return null;

  return (
    <Button.Group>
      {catalog.groups.map((group) => {
        const reports = group.reports.map((report) => ({
          ...report,
          in_layout: layoutKeys.has(report.key),
        }));
        const available = reports.filter((report) => !report.in_layout);

        return (
          <Menu key={group.element_type} position="bottom-start" withinPortal>
            <Menu.Target>
              <Button variant="default" size="xs">
                + {group.label}
              </Button>
            </Menu.Target>
            <Menu.Dropdown>
              <Menu.Label>Add {group.label.toLowerCase()}</Menu.Label>
              {reports.map((report) => (
                <Menu.Item
                  key={report.key}
                  leftSection={report.in_layout ? <IconCheck size="var(--axio-unit-14)" /> : <IconPlus size="var(--axio-unit-14)" />}
                  disabled={report.in_layout}
                  onClick={() => onAdd(report)}
                >
                  <Text size="sm">{report.title}</Text>
                </Menu.Item>
              ))}
              {available.length === 0 && (
                <>
                  <Menu.Divider />
                  <Menu.Item disabled>All on dashboard</Menu.Item>
                </>
              )}
            </Menu.Dropdown>
          </Menu>
        );
      })}
    </Button.Group>
  );
}
